import { pageProperties } from './utils/base';
import { init as initEvents } from './components/events';
import { reportProductImpressions, reportPromoImpressions } from './components/impressions';
import { webVitals } from './components/webVitals';

/**
 * @typedef {InstanceType<typeof import('widgets/toolbox/RefElement').RefElement>} refElement
 */
/**
 * @description clientGTM
 * @module clientGTM
 * @category widgets
 * @subcategory int_gtm
 */

declare global {
    interface Window {
        gtmUserData: {
            login_status: boolean;
        };
        gtmGenericData: {
            currencyCode: string;
            pdpGalleryTrackingEnabled?: boolean;
            pdpVideoTrackingEnabled?: boolean;
        };
        gtmSalesforceExperiments?: Array<{
            test_id: string;
            segment_id: string;
            is_control_group: boolean;
        }>;
    }
    interface IProductGtmInfo {
        id: string;
        name: string;
        category: string;
        quantity: number;
        price: string;
        position?: string;
    }
}

/**
 * @description Init GTM callback
 */
function init() {
    if (pageProperties.currentCurrency === '') {
        pageProperties.currentCurrency = window?.gtmGenericData?.currencyCode;
    }

    initEvents();
    webVitals();
    reportProductImpressions();

    reportPromoImpressions();
}

if (window.dataLayer) {
    if (document.readyState === 'loading') {
        /**
         * @description Init gtm once dom content loaded
         * @listens dom:DOMContentLoaded
         */
        document.addEventListener(
            'DOMContentLoaded',
            () => {
                setTimeout(() => {
                    init();
                }, 0);
            },
            { once: true }
        );
    } else {
        init();
    }
}
